(function () {
  if (window.AurolisPromoData) return;
  const CACHE_KEY = "aurolis-promo-catalog-v2";
  let activePromise = null;
  let activeKey = "";
  function getTags(product) {
    const raw = product && product.tags;
    const tags = Array.isArray(raw) ? raw : (typeof raw === "string" ? raw.split(",") : []);
    return tags.map(tag => String(tag || "").trim()).filter(Boolean);
  }
  function tagValue(tags, prefix) {
    const re = new RegExp("^(?:" + prefix + ")[_:](.+)$", "i");
    for (const tag of tags) {
      const match = tag.match(re);
      if (match) return match[1].trim().replace(/_/g, " ");
    }
    return "";
  }
  function tagValues(tags, prefix) {
    const re = new RegExp("^(?:" + prefix + ")[_:](.+)$", "i");
    return tags.map(tag => {
      const match = tag.match(re);
      return match ? match[1].trim().replace(/_/g, " ") : "";
    }).filter(Boolean);
  }
  function mapVariant(product, variant) {
    const tags = getTags(product);
    const codeTag = tags.find(tag => /^[MW]\s*0*\d+$/i.test(tag));
    const codeMatch = codeTag && codeTag.match(/^([MW])\s*0*(\d+)$/i);
    const title = codeMatch ? codeMatch[1].toUpperCase() + Number(codeMatch[2]) : (codeTag || product.title || "");
    const rawGender = tagValue(tags, "geschlecht|gender").toLocaleLowerCase("de");
    let gender = "";
    if (/^(herren|herrenduft|mann|maenner|männer|male)$/.test(rawGender)) gender = "Herren";
    else if (/^(damen|damenduft|frau|frauen|female)$/.test(rawGender)) gender = "Damen";
    else if (rawGender === "unisex") gender = "Unisex";
    if (!gender && codeMatch) gender = codeMatch[1].toUpperCase() === "M" ? "Herren" : "Damen";
    const directions = tagValues(tags, "duftrichtung|direction");
    const notes = tagValues(tags, "duftnote|note");
    const featured = product.featured_image;
    const images = Array.isArray(product.images) ? product.images : [];
    const image = (typeof featured === "string" ? featured : featured && (featured.src || featured.url)) ||
      (images[0] && (images[0].src || images[0].url)) || "";
    return {
      id: String(variant.id), sku: String(variant.sku || ""), title: String(title),
      handle: String(product.handle || ""), gender, directions, notes,
      image: String(image), alt: "Aurolis " + String(title),
      search: [title, product.title, product.handle, variant.sku, ...tags].filter(Boolean).join(" ")
    };
  }
  async function fetchCollectionProducts(endpoint) {
    if (!endpoint) throw new Error("Die Aktionskollektion ist nicht konfiguriert.");
    const products = [], seen = new Set();
    for (let page = 1; page <= 40; page++) {
      const url = endpoint + (endpoint.includes("?") ? "&" : "?") + "limit=250&page=" + page;
      const response = await fetch(url, { credentials: "same-origin", headers: { "Accept": "application/json" } });
      if (!response.ok) throw new Error("Die Aktionskollektion konnte nicht geladen werden.");
      const payload = await response.json();
      if (!payload || !Array.isArray(payload.products)) throw new Error("Shopify hat keine Produktliste zurückgegeben.");
      const batch = payload.products, before = products.length;
      for (const product of batch) {
        const id = String(product.id || product.handle || "");
        if (!id || seen.has(id)) continue;
        seen.add(id); products.push(product);
      }
      if (batch.length < 250) break;
      if (products.length === before) throw new Error("Die Produktliste konnte nicht vollständig geladen werden.");
      if (page === 40) throw new Error("Die Produktliste überschreitet die sichere Seitenbegrenzung.");
    }
    return products;
  }
  async function load(buyUrl, giftUrl) {
    const key = String(buyUrl || "") + "|" + String(giftUrl || "");
    if (activePromise && activeKey === key) return activePromise;
    activeKey = key;
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed && parsed.key === key && Date.now() - Number(parsed.savedAt || 0) < 120000 &&
          parsed.data && Array.isArray(parsed.data.buyVariantIds) && Array.isArray(parsed.data.giftVariants)) {
          activePromise = Promise.resolve(parsed.data);
          return activePromise;
        }
      }
    } catch (error) {}
    activePromise = (async function () {
      const buyProducts = await fetchCollectionProducts(buyUrl);
      const giftProducts = giftUrl === buyUrl ? buyProducts : await fetchCollectionProducts(giftUrl);
      const buyVariantIds = [];
      for (const product of buyProducts) for (const variant of (Array.isArray(product.variants) ? product.variants : [])) {
        if (variant && variant.title === "50 ml Spray" && variant.available !== false) buyVariantIds.push(String(variant.id));
      }
      const giftByCode = new Map();
      const excludedGiftCodes = new Set(["M79", "M159", "M160", "M162", "CCBA"]);
      for (const product of giftProducts) {
        // BOGOS/SCA creates duplicate draft products with synthetic gift handles.
        // They must never appear as customer-selectable Aurolis fragrances.
        if (/sca_clone_freegift/i.test(String(product.handle || ""))) continue;
        for (const variant of (Array.isArray(product.variants) ? product.variants : [])) {
          if (!variant || variant.title !== "30 ml Spray" || variant.available === false) continue;
          const gift = mapVariant(product, variant);
          const tags = getTags(product);
          const excludedByTag = tags.some(tag => tag.toLocaleLowerCase("de") === "aurolis_3plus1_ausschluss");
          const identity = [gift.title, product.title, product.handle, ...tags].join(" ").toUpperCase();
          const excludedByCode = [...excludedGiftCodes].some(code =>
            new RegExp("(^|[^A-Z0-9])" + code + "([^A-Z0-9]|$)").test(identity)
          );
          if (excludedByTag || excludedByCode) continue;

          // More than one Shopify product currently carries a few identical M/W codes.
          // Keep one canonical, size-correct 30-ml variant per fragrance code.
          const key = String(gift.title || "").trim().toLocaleLowerCase("de");
          if (!key) continue;
          const codeMatch = key.match(/^([mw])0*(\d+)$/i);
          const codeType = codeMatch ? codeMatch[1].toUpperCase() : "";
          const codeNumber = codeMatch ? Number(codeMatch[2]) : NaN;
          let score = 0;
          const skuMatch = String(variant.sku || "").toUpperCase().match(/^(AM|AW|M|W)[-_ ]*0*(\d+)(?:[-_ ]|$)/);
          if (skuMatch && codeType && Number(skuMatch[2]) === codeNumber) score += 100;
          else if (skuMatch && codeType) score -= 100;
          if (skuMatch && codeType) score += (skuMatch[1].endsWith("W") ? "W" : "M") === codeType ? 50 : -50;

          const handleMatch = String(product.handle || "").match(/^(am|aw)-0*(\d+)$/i);
          if (handleMatch && codeType && Number(handleMatch[2]) === codeNumber) score += 20;
          else if (handleMatch && codeType) score -= 20;
          if (handleMatch && codeType) score += (handleMatch[1].toUpperCase().endsWith("W") ? "W" : "M") === codeType ? 10 : -10;

          const titleMatch = String(product.title || "").match(/^(AM|AW)-0*(\d+)$/i);
          if (titleMatch && codeType && Number(titleMatch[2]) === codeNumber) score += 5;
          else if (titleMatch && codeType) score -= 5;
          if (titleMatch && codeType) score += (titleMatch[1].toUpperCase().endsWith("W") ? "W" : "M") === codeType ? 2 : -2;

          const existing = giftByCode.get(key);
          if (!existing || score > existing.score) giftByCode.set(key, { gift, score });
        }
      }
      const giftVariants = [...giftByCode.values()].map(item => item.gift);
      if (!buyVariantIds.length) throw new Error("Es wurden keine verfügbaren 50-ml-Aktionsdüfte gefunden.");
      if (!giftVariants.length) throw new Error("Es wurden keine verfügbaren 30-ml-Gratisdüfte gefunden.");
      const data = { buyVariantIds: [...new Set(buyVariantIds)], giftVariants };
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ key, savedAt: Date.now(), data })); } catch (error) {}
      return data;
    })();
    activePromise.catch(function () { if (activeKey === key) activePromise = null; });
    return activePromise;
  }
  window.AurolisPromoData = { load };
})();